import React from 'react';
import styles from './styles.module.scss';
import FooterABC from '../../containers/Footer/footerABC';
import { H4, H5 } from '../../components';

const termAndConditionsText = [
  {
    title: 'WEBSITE AND APPLICATION USAGE STATISTICS',
    text: 'Our servers gather statistics on user behavior. This information is used to improve our website and/or applications.'
      + ' These statistics are typically generated in aggregate form, and usually do not contain anything more personal than the IP'
      + ' address of the visiting user, what page or screen was visited and when, and the type of browser and/or operating system.',
  },
  {
    title: 'COOKIES',
    text: 'We may use cookies to store small pieces of session data. This data may include (but is not limited to)'
      + ' login names, last login, affiliate link and other such information. Our intent is to use cookies to enable'
      + ' certain features on our site that could not be implemented any other way, such as automatic login capabilities.'
      + ' We do not use cookies for the purposes of advertising, either on our site or via email solicitations.',
  },
  {
    title: 'EMAIL ANNOUNCEMENTS',
    text: 'We may, from time to time, send email announcements to our users. Your'
      + ' email will not be visible to other users in our announcements. If you do not wish to receive'
      + ' announcements, you can opt out at any time by emailing support@omahapro.com with your request.',
  },
  {
    title: 'PUBLIC AND PRIVATE DATA',
    text: 'Certain parts of our website (comment and reviews) allow you to make your data public'
      + ' for other users to view. Once you make your data public, we cannot guarantee the privacy'
      + ' of that data, even if you decide to make it private again in the future.'
      + 'Any private data is not shared or transferred to third-parties.',
  },
  {
    title: 'SECURITY',
    text: 'We take reasonable precautions to ensure your privacy (such as password'
      + ' protection of private information), however, we are not responsible in the unlikely event'
      + ' that your private information is compromised.',
  },
  {
    title: 'TRANSFER OF INFORMATION',
    text: 'We reserve the right to transfer your personal information in the event of a sale'
      + ' of part or all of PloPraidas LP assets or stock.',
  },
  {
    title: 'CHANGES TO THE PRIVACY POLICY',
    text: 'This privacy policy may change in the future. Any changes to our policy'
      + ' will be reflected in this web page.',
  },
];

const Privacy = () => (
  <section className={styles.termAndConditionsTextWrapper}>
    <div className={styles.termAndConditionsText}>
      {
        termAndConditionsText.map((item) => (
          <div key={item.title}>
            <H4 className={styles.title}>{item.title}</H4>
            <H5>{item.text}</H5>
          </div>
        ))
      }
    </div>
    <FooterABC />
  </section>
);

export default Privacy;
